import { EventListData } from '~admin/model/event-list-data';
import { datetime } from '~common/helper/datetime';

/**
 * Returns a list of current and upcoming events filtering out past events
 * @param events
 */
export const currentAndUpcomingEvents = (events: EventListData[]): EventListData[] =>
  events.filter((event) => !datetime.isPast(event.eventEndDate));



// WEBPACK FOOTER //
// ./helper/event-list-data.predicate.ts